export enum EnumApiTonghao {
  Moments = '/moment/api/moments/mix/bytopic',
  FollowsMoments = '/moment/api/moments/follows',
  RecommendCitys = '/party/api/guild/recommend/list',
  Myself = '/party/api/guild/myself',
  GuildList = '/party/api/guild/list',
  GuildEstablished = '/party/api/guild/established',
  GuildDetail = '/party/api/guild/detail',
  GuildJoin = '/party/api/guild/member/join/{guildId}',
  Guildcreate = '/party/api/guild/member/create',
  MemberList = '/party/api/guild/member/list',
  MemberJoinGroup = '/party/api/guild/member/group/join',
  MemberReview = '/party/api/guild/member/exit/review',
  MemberApplyExit = '/party/api/guild/member/exit/{guildId}'
}
